<template>
  <label :class="$style.toggle">
    <slot />
    <input v-model="localValue" type="checkbox" :class="$style.toggleInput" :disabled="disabled" />
    <span :class="[$style.slider, { [$style.disabled]: disabled }]"></span>
  </label>
</template>

<script lang="ts" setup>
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    modelValue: boolean
    /** 非活性 */
    disabled?: boolean
  }>(),
  {
    disabled: false,
  },
)

const emit = defineEmits<{
  (e: "update:modelValue", modelValue: boolean): void
}>()

const localValue = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
})
</script>

<style scoped module lang="scss">
.toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  .toggleInput {
    display: none;
    &:checked {
      + .slider {
        background-color: $primary;
        border: 1px solid $white;
        &:before {
          transform: translateX(1.25rem);
          background-color: $white;
        }
        &.disabled {
          background-color: $black-40;
        }
      }
    }
    &:focus {
      + .slider {
        box-shadow: 0 0 1px $primary;
      }
    }
    &:disabled + .slider {
      cursor: not-allowed;
    }
  }
  .slider {
    position: relative;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 3.375rem;
    height: 2rem;
    background-color: $primary-20;
    border: 1px solid $primary-20;
    transition: background-color 0.2s;
    border-radius: 1rem;
    &:before {
      position: absolute;
      content: "";
      border-radius: 1rem;
      height: 1.375rem;
      width: 1.375rem;
      left: 4px;
      bottom: 4px;
      background-color: $white;
      transition: 0.2s;
    }
    &.disabled {
      &:before {
        background-color: $black-10;
      }
    }
  }
}
</style>
